import React, { Component } from 'react';

class ServiceTabDesktop extends Component {

    render() {
        return (
            <div className={'tab ' + (this.props.active ? 'active' : '')} onClick={this.props.handleClick}>
                <div className="tab-mask tab-mask-top" />
                <div className="tab-mask tab-mask-bottom" />
                <div className="img" />
                <h3>{this.props.title}</h3>
                <p>{this.props.subTitle}</p>
                <a href="#" onClick={e => e.preventDefault()}>Read More</a>
            </div>
        );
    }

}

export default ServiceTabDesktop;


// WEBPACK FOOTER //
// ./resources/assets/js/homepage/ServiceTabDesktop.js